import useAuthenticatorEnrollments from './useAuthenticatorEnrollments';

export default useAuthenticatorEnrollments;
